export const sendCancelPostMessage = () => {
  if (window.location !== window.parent.location) {
    window.parent.postMessage({ type: 'cancel' }, '*');
  }

  if (window.opener && window !== null && window.opener !== null && !!window.opener.postMessage) {
    window.opener.postMessage({ type: 'cancel' }, '*');
  }
};

export const sendWhatsappPostMessage = (paramsUrl: string) => {
  if (window.location !== window.parent.location) {
    window.parent.postMessage({ type: 'whatsapp', paramsUrl }, '*');
  }
};

export const sendExcludedPostMessage = () => {
  if (window.location !== window.parent.location) {
    window.parent.postMessage({ type: 'excluded' }, '*');
  }

  if (window.opener && window !== null && window.opener !== null && !!window.opener.postMessage) {
    window.opener.postMessage({ type: 'excluded' }, '*');
  }
};

export const scrollTo = (elementId: string, options: ScrollOptions) => {
  const element = document.getElementById(elementId);

  if (!element) return;

  if (element.scroll) {
    element.scroll({
      top: options.top,
      behavior: options.behavior || 'smooth',
    });
    return;
  }

  element.scrollTop = options.top;
};

interface ScrollOptions {
  top: number;
  behavior?: 'smooth' | 'auto';
}

export const safeGetFromLocalStorage = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const safeSetInLocalStorage = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    //  não precisamos fazer nada aqui, se deu erro provavelmente está em janela anonima ou cookie bloqueado
  }
};

export const safeDeleteFromLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    //  não precisamos fazer nada aqui, se deu erro provavelmente está em janela anonima ou cookie bloqueado
  }
};
